export const QUOTA_MANAGER_MODES = {
  PREVIEW: 'preview',
  MANAGE: 'manage',
};
